import { Confirmation, ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs';

export type ConfirmActionOptions = Required<Pick<Confirmation, 'message' | 'header'>> &
  Pick<Confirmation, 'icon' | 'acceptLabel' | 'rejectLabel' | 'acceptButtonStyleClass' | 'rejectButtonStyleClass'>;

export function confirmAction(confirmationService: ConfirmationService, options: ConfirmActionOptions): Observable<boolean> {
  return new Observable<boolean>((observer) => {
    confirmationService.confirm({
      message: options.message,
      header: options.header,
      icon: options.icon ?? 'pi pi-exclamation-triangle',
      acceptLabel: options.acceptLabel,
      rejectLabel: options.rejectLabel,
      acceptButtonStyleClass: options.acceptButtonStyleClass ?? 'p-button-success',
      rejectButtonStyleClass: options.rejectButtonStyleClass ?? 'p-button-secondary p-button-outlined',
      accept: () => {
        observer.next(true);
        observer.complete();
      },
      reject: () => {
        observer.next(false);
        observer.complete();
      },
    });
  });
}
